module.exports = __webpack_public_path__ + "static/img/img_activity_b.7e339bf5.png";